import moment from "moment";
import { Chart } from "chart.js";
import "chartjs-adapter-moment";
import "chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes";
import { Tableau20 } from "chartjs-plugin-colorschemes/src/colorschemes/colorschemes.tableau";
import "chartjs-plugin-zoom";
import numbro from "numbro";

moment.locale("pt-br");

Chart.plugins.register({
  beforeDraw(chart) {
    const { ctx } = chart.chart;
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, chart.chart.width, chart.chart.height);
  },
  afterDraw(chart) {
    if (chart.data.datasets.length === 0) {
      const { ctx, width, height } = chart.chart;

      chart.clear();

      ctx.save();
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = "20px 'Helvetica'";
      ctx.fillText("Nenhum dado a ser exibido", width / 2, height / 2);
      ctx.restore();
    }
  }
});

const defaultLegendClickHandler = Chart.defaults.global.legend.onClick;

const defaultOptions = {
  responsive: true,
  aspectRatio: 1,
  maintainAspectRatio: false,
  responsiveAnimationDuration: 0,
  animation: {
    duration: 0
  },
  plugins: {
    colorschemes: {
      scheme: Tableau20
    },
    zoom: {
      zoom: {
        enabled: true,
        drag: {
          animationDuration: 0,
          borderColor: "rgba(13, 71, 161, 0.4)",
          borderWidth: 1,
          backgroundColor: "rgba(144, 202, 249, 0.4)"
        },
        sensitivity: 0,
        mode: "xy"
      }
    }
  },
  legend: {
    position: "bottom",
    onClick(event, legendItem) {
      defaultLegendClickHandler.call(this, event, legendItem);
      this.chart.resetZoom();
    }
  },
  tooltips: {
    position: "nearest",
    mode: "nearest",
    intersect: false,
    callbacks: {
      label(tooltipItem, data) {
        let label = data.datasets[tooltipItem.datasetIndex].label || "";

        if (label) {
          label += ": ";
        }

        label += +numbro(tooltipItem.yLabel).format({
          mantissa: 4
        });

        return label;
      }
    }
  }
};

const tickOptions = Object.freeze({
  maxTicksLimit: 9,
  callback(value) {
    return `${+numbro(value).format({
      mantissa: 4
    })}`;
  }
});

export { Chart, tickOptions, defaultOptions };
